import { render, staticRenderFns } from "./DetailsAnnualUsageBox.vue?vue&type=template&id=e5c05aa2"
import script from "./DetailsAnnualUsageBox.vue?vue&type=script&lang=ts"
export * from "./DetailsAnnualUsageBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports